import { useState } from "react";
import { NavLink, Link } from "react-router-dom";

function NavBar() {
  const [isNavOpen, setIsNavOpen] = useState(false);

  const genericHamburgerLine =
    "h-1 w-8 my-1 bg-black transition ease transform duration-300";

  const navLinkClass = ({ isActive }) =>
    isActive
      ? "font-bold leading-loose"
      : "leading-loose";

  const mobileLinks = [
    { to: "/", label: "Campus" },
    { to: "/EG", label: "EG" },
    { to: "/first-floor", label: "1. Stock" },
    { to: "/second-floor", label: "2. Stock" },
    { to: "/UG", label: "UG" },
    { to: "/about", label: "About" },
  ];

  return (
    <header
      className={`z-50 w-full ${
        isNavOpen ? "fixed top-0 left-0 bg-white" : ""
      }`}
    >
      <div className="flex justify-between items-center w-[95%] lg:w-4/6 mx-auto lg:mt-6">
        <div className="flex z-50 ml-2 lg:ml-0">
          <Link to="/">BM-Campus</Link>
        </div>

        <nav>
          <div className="hidden lg:block">
            <ul className="flex items-center">
              <li className="mr-6">
                <NavLink to="/" className={navLinkClass}>
                  Campus
                </NavLink>
              </li>
              <li className="mr-6">
                <NavLink to="/EG" className={navLinkClass}>
                  EG
                </NavLink>
              </li>
              <li className="mr-6">
                <NavLink to="/first-floor" className={navLinkClass}>
                  1. Stock
                </NavLink>
              </li>
              <li className="mr-6">
                <NavLink to="/second-floor" className={navLinkClass}>
                  2. Stock
                </NavLink>
              </li>
              <li className="mr-6">
                <NavLink to="/UG" className={navLinkClass}>
                  UG
                </NavLink>
              </li>
              <li className="mr-6">
                <NavLink to="/about" className={navLinkClass}>
                  About
                </NavLink>
              </li>
            </ul>
          </div>

          <div className="lg:hidden">
            <button
              aria-label="menu-button"
              className="relative z-50 flex flex-col h-12 w-12 justify-center items-center"
              onClick={() => setIsNavOpen(!isNavOpen)}
            >
              <div
                className={`${genericHamburgerLine} ${
                  isNavOpen ? "rotate-45 translate-y-3" : ""
                }`}
              />
              <div
                className={`${genericHamburgerLine} ${
                  isNavOpen ? "opacity-0" : ""
                }`}
              />
              <div
                className={`${genericHamburgerLine} ${
                  isNavOpen ? "-rotate-45 -translate-y-3" : ""
                }`}
              />
            </button>
          </div>
        </nav>
      </div>

      <div
        className={`fixed inset-0 z-40 bg-white lg:hidden transition-opacity duration-200 ${
          isNavOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <ul className="flex flex-col items-center justify-center h-full text-center text-xl">
          {mobileLinks.map((link, index) => (
            <li
              key={link.to}
              className={`mb-6 transform transition-all duration-400 ease-out ${
                isNavOpen
                  ? "translate-x-0 opacity-100"
                  : "-translate-x-10 opacity-0"
              }`}
              style={{
                transitionDelay: isNavOpen ? `${index * 80}ms` : "0ms",
              }}
            >
              <NavLink
                to={link.to}
                className={navLinkClass}
                onClick={() => setIsNavOpen(false)}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}

export default NavBar;